import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AnalysisWidget from "../../../../../../Analysis/widget";
import Chart from "../../../../../pme/screens/dashboard/widgets/sdgs/chart";

export default function FormCompletion() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.authentication);
  const percentage = user?.amp?.ampCompletionPercentage || 0;

  return (
    <AnalysisWidget
      title={t('Application Form Completion')}
      className="with-border-header custom-width-b">
      <Chart
        t={t}
        isEmpty
        customBody={(
          <p>{Number(Math.round(percentage)).toLocaleString('en-us')}%</p>
        )}
        data={[{ percent: percentage / 100, color: 'var(--color-primary-70)' }]}
        renderTooltip={() => null}
        className="small-chart-thin"
      />
    </AnalysisWidget>
  )
}
